import React, { useEffect, useState, Fragment } from "react";
import { useRespuesta } from "../../data/RespuestaContext";
import { useProyecto } from "../../data/ProyectoContext";
import {
  Button,
  Card,
  CardContent,
  Grid,
  Box,
  styled,
  Typography,
} from "@mui/material";
import EditableField from "../GrillaProyectos/EditableField";
import { useJobContext } from "../../hooks/Jobs";
import { config } from "../../config/configLabels";
import { v4 as uuidv4 } from "uuid";
import DraggableGrid from "../Table/DraggableGrid";

const initialStateColumns = [
  {
    Header: "Clase",
    accessor: "sesion",
  },
  {
    Header: "Contenido",
    accessor: "tema",
  },
];

const PropuestasUnidadActiva = ({ itemProyecto, indexPropuesta, color }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { etapa, tipoEstructura } = useJobContext();
  const { setRespuestaData, respuesta } = useRespuesta();
  const { enviarProyecto } = useProyecto();
  const [labels, setLabels] = useState([]);
  const [columns] = useState(initialStateColumns);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const load = () => {
      const labels = config[etapa]?.[tipoEstructura] || [];
      setLabels(labels);
      loadDataTable(itemProyecto);
    };
    if (itemProyecto) {
      load();
    }
  }, [itemProyecto, etapa]);

  useEffect(() => {
    setIsLoading(false);
  }, [labels.length > 0]);

  const handleSave = (indexPropuesta, label, newValue) => {
    if (respuesta && respuesta.propuestas) {
      const nuevasPropuestas = respuesta.propuestas;
      nuevasPropuestas[indexPropuesta][label] = newValue;
      const updatePropuesta = {
        ...respuesta,
        propuestas: nuevasPropuestas,
      };
      setRespuestaData(updatePropuesta);
    } else {
      console.log("No hay respuesta o propuestas disponibles");
    }
  };

  const loadDataTable = (itemProyecto) => {
    setTableData(agrupacionPorSemanas(itemProyecto.temas));
  };

  const handleSelect = (itemSeleccionado) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    itemSeleccionado.temas = tableData.flatMap((d) => d.sesiones);
    enviarProyecto(itemSeleccionado, etapa);
  };

  const agrupacionPorSemanas = (temas) => {
    return temas.reduce((acc, tema) => {
      let week = acc.find((w) => w.semana === tema.semana);
      if (!week) {
        week = { semana: tema.semana, sesiones: [] };
        acc.push(week);
      }
      week.sesiones.push({ ...tema, id: uuidv4() });
      return acc;
    }, []);
  };

  return (
    <Grid key={indexPropuesta} item xs={12} md={12}>
      {isLoading && <>...cargando</>}

      {!isLoading && (
        <Card
          key={indexPropuesta}
          sx={{
            display: "flex",
            m: 2,
            width: "98%",
            border: 1,
            borderColor: "divider",
            borderRadius: 2,
          }}
        >
          <CardContent sx={{ fontFamily: "Montserrat", width: "100%" }}>
            <EditableField
              label={"Plan Académico"}
              value={itemProyecto.plan_academico}
              onSave={(newValue) =>
                handleSave(indexPropuesta, "plan_academico", newValue)
              }
            />
            <br />
            <br />
            <Typography
              variant="h5"
              style={{
                textAlign: "center",
                fontFamily: "Montserrat",
                fontWeight: "bold",
                color: "#336B87",
              }}
            >
              Cronograma sugerido
            </Typography>
            {tableData.map((data, weekIndex) => (
              <Fragment key={weekIndex}>
                <Box display="flex" sx={{ marginLeft: "18px" }}>
                  <Box
                    sx={{
                      width: "95%",
                      fontFamily: "Montserrat",
                      fontSize: "0.8rem",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        fontFamily: "Montserrat",
                        color: "#336B87",
                      }}
                    >
                      Semana {data.semana}
                    </Typography>
                    <br />
                    <DraggableGrid
                      columns={columns}
                      rows={data.sesiones}
                      setRows={(newRows) => {
                        const newData = [...tableData];
                        newData[weekIndex].sesiones = newRows;
                        setTableData(newData);
                      }}
                    />
                    <br />
                    <br />
                  </Box>
                </Box>
              </Fragment>
            ))}

            <Button
              variant="contained"
              color="success"
              sx={{
                m: "auto",
                mt: 5,
                p: "5px",
                width: "50%",
                left: "20%",
                right: "15%",
                borderRadius: 5,
                backgroundColor: "#336B87",
                "&:hover": {
                  backgroundColor: "#336B82",
                },
              }}
              onClick={() => handleSelect(itemProyecto)}
              data-amplify-analytics-on="click"
              data-amplify-analytics-name={`click-on-seleccionarPropuesta`}
              data-amplify-analytics-attrs={`onClick:handleSelect etapa=${etapa}, tipoEstructura:${tipoEstructura}`}
            >
              Seleccionar
            </Button>
          </CardContent>
        </Card>
      )}
    </Grid>
  );
};

export default PropuestasUnidadActiva;
